import { FC, ReactNode } from 'react';
import { Box, BoxProps, Text, TextProps } from '@chakra-ui/react';

const DescList: FC<BoxProps> = (props) => <Box as="dl" {...props} />;

export const ListItem: FC<{ term: ReactNode } & TextProps> = ({
  term,
  children,
  ...props
}) => (
  <>
    <Text as="dt" {...props}>
      {term}
    </Text>
    <Text as="dd">{children}</Text>
  </>
);

export default DescList;
